export default __webpack_public_path__ + "static/media/topicTwitter.c1d121ed.png";